import { createContext } from "react";

/** User-facing theme preference. ``"system"`` follows the OS-level
 *  prefers-color-scheme; ``"light"`` and ``"dark"`` are explicit
 *  overrides. (#161) */
export type ThemePreference = "system" | "light" | "dark";

export interface ThemeContextValue {
  /** The user's saved preference. */
  readonly preference: ThemePreference;
  /** The resolved theme actually applied to ``<html>`` - ``"system"``
   *  collapses to either light or dark based on the browser. */
  readonly resolved: "light" | "dark";
  readonly setPreference: (next: ThemePreference) => void;
}

/** Empty initial value - ``useTheme()`` throws if a consumer mounts
 *  outside ``<ThemeProvider>``, which catches the bug in dev. */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
